
import { post } from '@/common/request';

const takeOffAuditMap = new Map([
  ['list', '/tenant/examineOrder/page'],
  ['reject', '/tenant/examineOrder/reject'],
  ['pass', '/tenant/examineOrder/pass'],
  ['onlineDetail', '/tenant/examineOrder/online/detail'],
  ['offlineDetail', '/tenant/examineOrder/offline/detail'],
  ['edit', '/tenant/examineOrder/edit/detail'],
  ['batchOnline', '/tenant/spot/batchOnline'],
  ['batchOffline', '/tenant/spot/batchOffline'],
  ['online', '/tenant/spot/online'],
  ['offline', '/tenant/spot/offline']
]);


export default takeOffAuditMap;


/**
 * 【资源审核】列表
 * https://yapi.lanhanba.com/project/399/interface/api/39409
 */
export async function getExamineOrderList(params?: any) {
  return post('/tenant/examineOrder/page', params, { proxyApi: '/resserv', needHint: true });
}

/**
 * 【标签审核】详情
 * https://yapi.lanhanba.com/project/399/interface/api/39234
 */
export async function getExamineOrderDetail(params?: any) {
  return post('/tenant/examineOrder/detail', params, { proxyApi: '/resserv', needHint: true });
}

/**
 * 【资源审核】通过
 * https://yapi.lanhanba.com/project/399/interface/api/39437
 */
export async function postExamineOrderPass(params?: any) {
  return post('/tenant/examineOrder/pass', params, { proxyApi: '/resserv', needHint: true });
}

/**
 * 【资源审核】拒绝
 * https://yapi.lanhanba.com/project/399/interface/api/39416
 */
export async function postExamineOrderReject(params?: any) {
  return post('/tenant/examineOrder/reject', params, { proxyApi: '/resserv', needHint: true });
}

/**
 * 【资源审核】上架审核详情
 * https://yapi.lanhanba.com/project/399/interface/api/39395
 */
export async function postExamineOrderOnlineDetail(params?: any) {
  return post('/tenant/examineOrder/online/detail', params, { proxyApi: '/resserv', needHint: true });
}

/**
 * 【资源审核】下架审核详情
 * https://yapi.lanhanba.com/project/399/interface/api/39402
 */
export async function postExamineOrderOfflineDetail(params?: any) {
  return post('/tenant/examineOrder/offline/detail', params, { proxyApi: '/resserv', needHint: true });
}

/**
 * 【资源审核】编辑审核详情
 * https://yapi.lanhanba.com/project/399/interface/api/39430
 */
export async function getExamineOrderEditDetail(params?: any) {
  return post('/tenant/examineOrder/edit/detail', params, { proxyApi: '/resserv', needHint: true });
}

